import { useMutation } from '@tanstack/react-query';
import { personApi } from 'service/api/personApi';
import { useNotification } from 'utils/notification/NotificationContext';
import type { CustomError } from '@dvag/dfs-api-client';
import i18next from 'i18next';
import { HttpStatusCode } from 'axios';

export const useUpdateLegalGuardian = (personId: string) => {
  const { showError } = useNotification();
  const personService = personApi();

  return useMutation<
    Awaited<ReturnType<typeof personService.updateLegalGuardian>>,
    CustomError,
    { legalGuardianNumber: number }
  >({
    mutationFn: (payload) => personService.updateLegalGuardian(personId, payload),
    onError: (error) => {
      showError({
        status: error?.status,
        description:
          error?.status === HttpStatusCode.Conflict
            ? i18next.t(
                'sendConsent.consentOrLegalGuardianModal.legalGuardian.legalGuardianIsMinor',
              )
            : error?.message,
      });
    },
  });
};
